var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['reportPanel-div']},[_c('i-col',{attrs:{"span":"7"}},[_c('div',{class:['list-form', _vm.skinClass]},[_c('span',{class:['iconStyle']},[_c('span',{class:['iconArea']},[_c('Icon',{attrs:{"type":_vm.icon,"size":"24"}})],1)]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cdd8422","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/report.vue
// module id = null
// module chunks = 